
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobb/[slug]",
      function () {
        return require("private-next-pages/jobb/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jobb/[slug]"])
      });
    }
  